const Layout = () => import('@/layout/index.vue');

export default {
  path: '/system',
  name: 'System',
  component: Layout,
  meta: {
    icon: 'briefcase',
    title: '系统工具',
    rank: 4,
    permission: ['root', 'admin', 'user']
  },
  children: [
    {
      path: '/system/users',
      name: 'Users',
      component: () => import('@/views/system/users/index.vue'),
      meta: {
        title: '用户管理',
        icon: 'user-filled'
      }
    },
    {
      path: '/system/roles',
      name: 'Roles',
      component: () => import('@/views/system/roles/index.vue'),
      meta: {
        title: '角色管理',
        icon: 'avatar'
      }
    }
  ]
};
